module.exports = __webpack_public_path__ + "static/media/dots.0d60e1b1.svg";